import React from "react";
import _ from "lodash";

import { NetworkAPI } from "apis";
import LoadingUI from "../../../common/LoadingUI";
import { notify } from "react-notify-toast";
import DateTimeFormatter from "components/common/DateTimeFormatter";
import { getFeaturesSchema } from "./FeaturesSchema";
import SchemaConfigTable from "components/common/SchemaConfigTable";
import ConfigDiffView from "components/control-center/auto-pilot/config/ConfigDiffView";
import PreviewFeaturesAndSaveModal from "./PreviewFeaturesAndSaveModal";
import PublisherInfoHeader from "./PublisherInfoHeader";

class PublisherFeaturesViewer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      errMsg: null,

      appName: null,
      config: null,
      updatedAt: null,

      schemasGrouped: null,
      isEditing: false,

      newConfig: null,
      isSaving: false,
      saveErrMsg: null,

      isReviewModalOpened: false,
    };

    this.handleConfigTextChanged = this.handleConfigTextChanged.bind(this);
    this.handleSaveRawFeatures = this.handleSaveRawFeatures.bind(this);

    this.handleApplyChanges = this.handleApplyChanges.bind(this);

    this.handleCloseReviewModal = this.handleCloseReviewModal.bind(this);
    this.handleOpenReviewModal = this.handleOpenReviewModal.bind(this);
  }

  async componentDidMount() {
    this.setState({ isLoading: true });
    try {
      const { pubId } = this.props.match.params;
      if (!pubId) {
        throw new Error("Missing Publisher ID");
      }

      const { defaults, schema } = await NetworkAPI.getFeaturesSchema();
      const schemasGrouped = getFeaturesSchema(defaults);

      const r = await NetworkAPI.getRawPublisherFeatures({ pubId });
      // console.log(r);

      this.setState({
        pubId,

        appName: r.app_name,
        // config: JSON.stringify(r.config, null, 4),
        // newConfig: JSON.stringify(r.config, null, 4),

        config: _.cloneDeep(r.config, null, 4),
        newConfig: _.cloneDeep(r.config, null, 4),
        updatedAt: r.updated_at,

        //new
        schemasGrouped,
        defaultConfig: defaults,

        isLoading: false,
        errMsg: null,
      });
    } catch (err) {
      console.log(err);
      this.setState({
        isLoading: false,
        errMsg: err.toString(),
      });
    }
  }

  handleConfigTextChanged(inputValue) {
    this.setState({ newConfig: inputValue });
  }

  async handleSaveRawFeatures() {
    this.setState({ isSaving: true });

    try {
      const { pubId, appName, newConfig } = this.state;
      const params = {
        pubId,
        appName,
        config: newConfig,
      };
      const r = await NetworkAPI.createPublisherFeatures(params);
      console.log("save result", r);
      this.setState({
        isSaving: false,
        saveErrMsg: null,
        config: _.cloneDeep(newConfig), // Clear diffs to prevent beforeunload alert
      });

      notify.show("Features saved! Automatically reloading page...", "success");

      setTimeout(() => {
        window.location.reload(false);
      }, 2000);
    } catch (err) {
      console.log("Failed to save publisher features", err);
      this.setState({
        isSaving: false,
        saveErrMsg: err.toString(),
      });
    }
  }

  handleApplyChanges({
    sectionConfigKey,
    configKey,
    newValue,
    isUseDefault,
    relatedConfig,
  }) {
    console.log("apply changes", {
      sectionConfigKey,
      configKey,
      newValue,
      isUseDefault,
      relatedConfig,
    });

    let newConfig = this.state.newConfig;

    function getConfigPath(configKey, sectionConfigKey = "") {
      return sectionConfigKey !== ""
        ? [sectionConfigKey, configKey]
        : configKey;
    }

    const configPathList = [
      {
        path: getConfigPath(configKey, sectionConfigKey),
        newValue,
        isUseDefault,
      },
      ...relatedConfig.map(({ prefix, key, newValue, isUseDefault }) => ({
        path: getConfigPath(key, prefix),
        newValue,
        isUseDefault,
      })),
    ];

    _.forEach(configPathList, ({ path, newValue, isUseDefault }) => {
      if (isUseDefault) {
        // remove from config
        _.unset(newConfig, path);
      } else {
        // add/edit to config
        _.set(newConfig, path, newValue);
      }
    });
    // empty keys with empty object or array value
    // eg. {"forerunner": {} } -> {}
    newConfig = _.omitBy(newConfig, (c) => {
      return typeof c === "object" && _.isEmpty(c);
    });

    this.setState({
      isEditing: false,
      newConfig,
    });
  }

  handleCloseReviewModal() {
    this.setState({ isReviewModalOpened: false });
  }

  handleOpenReviewModal() {
    this.setState({ isReviewModalOpened: true });
  }

  render() {
    const {
      pubId,

      config,
      updatedAt,

      isLoading,
      errMsg,

      newConfig,
      isSaving,
      saveErrMsg,

      schemasGrouped,
      isEditing,
      defaultConfig,

      isReviewModalOpened,
    } = this.state;

    return (
      <div>
        {isLoading && <LoadingUI></LoadingUI>}
        {errMsg && <div className="text-red-800">{errMsg}</div>}

        {pubId && (
          <div>
            <PublisherInfoHeader pubId={pubId}></PublisherInfoHeader>
            <div className="min-h-screen bg-white px-4 py-8">
              <div className="flex items-center justify-between pl-8">
                <PageTitle title="Publisher Features"></PageTitle>
              </div>

              <div className="flex w-full gap-4">
                <div className="mt-2 w-3/4">
                  <SchemaConfigTable
                    configSchemas={schemasGrouped}
                    newConfig={newConfig}
                    handleApplyChanges={(params) =>
                      this.handleApplyChanges({
                        ...params,
                        sectionConfigKey: params.prefix,
                      })
                    }
                    handleStartEditMode={() =>
                      this.setState({ isEditing: true })
                    }
                    handleCancelEditMode={() =>
                      this.setState({ isEditing: false })
                    }
                  ></SchemaConfigTable>
                  {/* <TextAreaWithJsonCheck
                    rows={18}
                    inputValue={config}
                    handleInputChanged={this.handleConfigTextChanged}
                  ></TextAreaWithJsonCheck> */}
                </div>

                <div className="w-1/4">
                  {updatedAt && (
                    <div className="mb-4 text-sm text-gray-600">
                      Last update time:
                      <br />
                      <DateTimeFormatter
                        datetime={updatedAt}
                      ></DateTimeFormatter>
                    </div>
                  )}

                  <div
                    className="overflow-y-auto"
                    style={{ maxHeight: "420px" }}
                  >
                    <ConfigDiffView
                      type="FEATURES"
                      originalConfig={config}
                      newConfig={newConfig}
                      defaultConfig={defaultConfig}
                    ></ConfigDiffView>
                  </div>

                  <div className="mt-4 flex justify-center">
                    <button
                      type="button"
                      className={`shadow rounded px-8 py-3 font-semibold ${
                        isSaving || isEditing
                          ? "cursor-not-allowed bg-gray-400 text-white"
                          : "bg-blue-400 text-white hover:bg-blue-600"
                      }`}
                      // onClick={this.handleSaveRawFeatures}
                      onClick={this.handleOpenReviewModal}
                      disabled={isSaving || isEditing}
                    >
                      Preview then save features
                    </button>
                  </div>
                  <div className="font-semibold text-red-600">{saveErrMsg}</div>
                </div>
              </div>

              <PreviewFeaturesAndSaveModal
                finalConfig={newConfig}
                isReviewModalOpened={isReviewModalOpened}
                handleCloseReviewModal={this.handleCloseReviewModal}
                isSaving={isSaving}
                saveErrMsg={saveErrMsg}
                handleConfirmSaveConfig={this.handleSaveRawFeatures}
              ></PreviewFeaturesAndSaveModal>
            </div>
          </div>
        )}
      </div>
    );
  }
}

function PageTitle({ title }) {
  return <div className="text-3xl font-extrabold">{title}</div>;
}

export default PublisherFeaturesViewer;
